import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import { parseStrapiContent } from "@lib/strapi/content";
import { StrapiMediaDTO } from "@lib/strapi/dtos/core/media.dto";
import { MDXRemoteSerializeResult } from "next-mdx-remote";
import { ImageProps } from "@lib/image";

export interface StrapiStepDTO extends StrapiDynamicZoneComponentDTO {
  heading: string;
  description: string;
  image: StrapiMediaDTO;
}

export class StepDTO extends DynamicZoneComponentDTO {
  constructor() {
    super();
  }

  heading: string;
  description: MDXRemoteSerializeResult;
  image: ImageProps;
}
